(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[87265],{

/***/ 83566:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/legal",
      function () {
        return __webpack_require__(80803);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ SeveralBrandsCategoryPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/layouts/severalBrandsWrapper.tsx + 9 modules
var severalBrandsWrapper = __webpack_require__(73191);
// EXTERNAL MODULE: ./src/components/severalbrands/metaTags/index.tsx
var metaTags = __webpack_require__(66405);
// EXTERNAL MODULE: ./src/components/severalbrands/HeroSection/index.tsx
var HeroSection = __webpack_require__(53276);
// EXTERNAL MODULE: ./src/components/severalbrands/legalPage/secondSection/index.tsx + 1 modules
var secondSection = __webpack_require__(23554);
// EXTERNAL MODULE: ./src/components/severalbrands/legalPage/thirdSection/index.tsx + 1 modules
var thirdSection = __webpack_require__(58721);
// EXTERNAL MODULE: ./src/components/severalbrands/utils/index.ts
var utils = __webpack_require__(54531);
;// CONCATENATED MODULE: ./src/components/severalbrands/legalPage/containers/legalGeneral/index.tsx







const secondSectionInfo = {
    img: "/severalbrands/assets/images/boostingClientAcquisitionImg.png",
    mainTitle: "Enhancing Client Intake for MVA Lawyers",
    paragraphs: [
        "Client acquisition is one of the toughest parts of running an MVA practice, especially for solo practitioners and small firms already juggling full caseloads. Too many lead sources deliver recycled contacts, vague ad copy, or leads that have already been shopped to multiple firms, and it can take a hundred low-quality leads to find one signable case. That combination drains both your team's time and your marketing budget.",
        "At Several Brands, we take a different approach: verified, high-intent leads generated through educational content and targeted campaigns, matched to your firm's criteria before they ever reach your intake team. The result is a more efficient intake process, so your team can spend less time chasing dead ends and more time practicing law.", 
    ],
    mainSectionClassName: `3xl:gap-[200px] lg:gap-16 gap-[40px] `,
    mainTitleClassName: "text-[#351C4F]",
    imgClassName: "w-[285px]  h-[240px] md:w-[650px] md:min-w-[650px] md:h-[550px] relative 3xl:w-[750px] 3xl:min-w-[750px] 3xl:h-[650px] 3xl:mt-16  "
};
const ourApproachList = [
    {
        title: "Define Your Perfect Case",
        description: "We start with a conversation to understand your firm's ideal case profile, geographic focus, and volume capacity, so every lead we send is a precise match for your practice."
    },
    {
        title: "Capture Intent in Real Time",
        description: "Our targeted campaigns reach potential clients at the moment that matters most, right after an accident, when they're actively looking for legal help. We filter for people with legitimate claims and a clear need for representation."
    },
    {
        title: "Verify and Deliver",
        description: "Before a lead reaches you, our system scrubs it for duplicates, confirms contact information, and validates incident details. Each lead is sold to one firm at a time; it is resold only if the buyer flags it as unsuitable."
    },
    {
        title: "Performance Feedback Loop",
        description: "You share performance data on the leads you receive, contacted, converted, or not a fit, which helps us see what's actually working."
    },
    {
        title: "KPI-Driven Success",
        description: "Together, we set clear KPIs for cost-effectiveness, and we optimize campaigns against those benchmarks to keep improving quality and conversions."
    },
    {
        title: "Ongoing Optimization",
        description: "We repeat steps 2 through 4, refining continuously, until we reach a rhythm that consistently meets the KPIs we've agreed on together."
    }, 
];
const growthList = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Powered by Advanced Digital Marketing Expertise",
        secondTitle: "SEO and SEM",
        paragraphs: [
            "Search engine marketing gets your firm in front of accident victims at the exact moment they're searching for legal help. Our large team of SEM professionals manages precisely targeted campaigns across Google, Bing, and Yahoo, driving high-intent traffic to conversion-focused landing pages. Alongside that, our content team builds SEO-optimized, educational content that earns organic authority over time, a slower path, but one that compounds into a durable, cost-effective source of traffic that keeps working long after a paid campaign ends.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] lg:ml-16 3xl:ml-20`,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#351C4F]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "Not every potential client is actively searching, so we reach them elsewhere, too. Our display strategy spans the Google Display Network, native platforms like Taboola and Outbrain, and other premium advertising networks, putting your firm in front of the right audience wherever they're already spending time online. With more than a decade of experience running these channels, we've refined our targeting to prioritize genuine conversion over simple impressions.", 
        ],
        mainSectionClassName: `lg:gap-[210px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#351C4F] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Reaching accident victims means doing so in the language they're most comfortable with, especially in a moment as stressful as the aftermath of a crash. For firms serving diverse communities, we build campaigns specifically localized for Spanish-speaking audiences and other language groups, adapting messaging and targeting so they resonate authentically rather than read as a translated afterthought.", 
        ],
        mainSectionClassName: `3xl:gap-[210px] lg:gap-[150px]  gap-[40px]  lg:ml-16 3xl:ml-20`,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#351C4F] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
const partnerData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: `At Several Brands, we're invested in your firm's growth, not just handing off leads and moving on. Every lead is sold to one firm at a time, and if something doesn't fit, a duplicate, a stale contact, or a case outside your criteria, we credit your account once it's verified, no hassle.`,
            className: "default"
        },
        {
            text: `Our pricing is performance-based and built around the metrics that actually matter to your practice: cost per lead, cost per acquisition, and ROI, not a flat retainer. Let's define what success looks like for your firm, and build a lead flow around it.`,
            className: "default"
        }, 
    ],
    buttonText: "Talk to Our Sales Team"
};
function LegalGeneralContainer() {
    const { domain , category  } = (0,useDomainContext/* useDomainContext */.w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(metaTags/* default */.Z, {
                title: category?.title ?? "Auto Accident Leads for Attorneys | SeveralBrands.com",
                description: description ?? "Get high-intent, pre-screened leads sold to one firm at a time. Several Brands delivers verified MVA cases directly to your intake team. Request a quote today.",
                keyWords: (0,utils/* getKeyWordsForMetaTags */.U8)(domain)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(secondSection/* default */.Z, {
                mainInfo: secondSectionInfo,
                approach: {
                    list: ourApproachList
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(thirdSection/* default */.Z, {
                growthList: growthList,
                partnerData: partnerData
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/severalbrands/legal/index.tsx




var __N_SSP = true;
function SeveralBrandsCategoryPage() {
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(severalBrandsWrapper/* default */.Z, {
        domainInfo: domain,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalGeneralContainer, {})
    });
}


/***/ }),

/***/ 54531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ getUrl; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "U8": function() { return /* binding */ getKeyWordsForMetaTags; },
/* harmony export */   "Z5": function() { return /* binding */ getMetaTitleDescriptionForPage; },
/* harmony export */   "_7": function() { return /* binding */ getDescriptionForPostByID; },
/* harmony export */   "_H": function() { return /* binding */ getMainTitlesNavigationFromBody; },
/* harmony export */   "fH": function() { return /* binding */ getFinalLogosForLogoSLider; },
/* harmony export */   "fx": function() { return /* binding */ getDescriptionForHomePage; },
/* harmony export */   "nn": function() { return /* binding */ addStyleClassToIframe; },
/* harmony export */   "qp": function() { return /* binding */ getKeyWordsForPostByID; },
/* harmony export */   "yV": function() { return /* binding */ addStyleClassToTable; }
/* harmony export */ });
/* unused harmony export extractExcerptFromBody */
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const getUrl = (pathname = "")=>{
    return `${window.location.origin}${pathname}`;
};
const getMainTitlesNavigationFromBody = (html)=>{
    const regex = /<[^>]+ id="([^"]+)"[^>]*>([\s\S]+?)<\/[^>]+>/g;
    const result = [];
    let match;
    while(match = regex.exec(html)){
        const [, id, content] = match;
        const textNodes = content.match(/>([^<]+)/g);
        if (textNodes) {
            result.push(// eslint-disable-next-line no-unsafe-optional-chaining
            ...textNodes?.map((node)=>({
                    value: node.substring(1).trim(),
                    id
                })));
        } else {
            result.push({
                value: content.trim(),
                id
            });
        }
    }
    return result.filter((i)=>i.value?.length > 1).map((el)=>({
            title: /^\d/.test(el.value) ? el.value.replace(/^\d/, "").slice(1) : el.value,
            link: `#${el.id}`
        }));
};
const addStyleClassToTable = (body)=>{
    if (body) {
        // start tag replace with <div className="table-responsive" > <table
        const firstSectionStartTag = body?.split("<table")[0]; // first section dose not contain <table to replace
        const bodyAfterReplaceStartTag = body?.split("<table").slice(1).map((table)=>{
            return `<div class="table-responsive"> <table ${table}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </table> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</table>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</table>").slice(1).map((table)=>{
            return `</table></div>${table}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const addStyleClassToIframe = (body)=>{
    if (body) {
        // start tag replace with <div className="iframe-responsive" > <iframe
        const firstSectionStartTag = body?.split("<iframe")[0]; // first section dose not contain <iframe to replace
        const bodyAfterReplaceStartTag = body?.split("<iframe").slice(1).map((iframe)=>{
            return `<div class="iframe-responsive"> <iframe ${iframe}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </iframe> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</iframe>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</iframe>").slice(1).map((iframe)=>{
            return `</iframe></div>${iframe}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const getFormattedDate = (date)=>{
    const regex = /^[0-9]+$/; //check if the string contain only numeric characters(time stamp)
    return new Date(regex.test(date) ? +date : date).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
const extractExcerptFromBody = (body, characters)=>{
    return body.replace(/<[^>]+>/g, "").substring(0, characters).trim();
};
const getDescriptionForPostByID = (post)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post.metatags[i]?.key === "description" && post.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.excerpt) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.excerpt, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    if (post?.body) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.body, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForPostByID = (post, domainInfo)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post?.metatags[i]?.key === "keywords" && post?.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.tags) {
        return post?.tags?.map((tag)=>tag?.name).join(",");
    }
    for(let i1 = 0; i1 < (domainInfo?.metatags.length ?? 0); i1++){
        if (domainInfo?.metatags[i1]?.key === "keywords" && domainInfo?.metatags[i1]?.value) {
            return domainInfo?.metatags[i1]?.value;
        }
    }
    return "";
};
const getDescriptionForHomePage = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "extra-meta-HomePage-meta-description" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    if (domain?.description) {
        return domain.description.replace(/<[^>]+>/g, "");
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForMetaTags = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "keywords" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    return "";
};
const getMetaTitleDescriptionForPage = (domain, keyPage)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        return {
            title: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-title`)?.value,
            description: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-description`)?.value
        };
    }
};
const getFinalLogosForLogoSLider = (featuredList, categorySlug)=>{
    const finalLogos = featuredList ? categorySlug ? featuredList[categorySlug] : featuredList["default"] : [];
    return finalLogos;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,83831,81711,239,49774,92888,40179], function() { return __webpack_exec__(83566); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);